import Translator from "../../../classes/Translator/Translator";
const CarbonCreditsWidgetLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};
export default CarbonCreditsWidgetLogic;
